<template>
  <div id="activity">
    <div class="main width1200">
      <div class="left">
        <activity-tree :activityId="activityId"/>
      </div>
      <div class="right">
        <activity-detail/>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityTree from './ActivityTree'
import ActivityDetail from './ActivityDetail'

export default {
  name: 'Acitvity',
  data () {
    return {
      activityId: this.$route.params.id
    }
  },
  components: { ActivityTree, ActivityDetail },
  methods: {
  }
}
</script>

<style lang="less">
  #activity {
    background-color: #0d0d0d;
    .main {
      display: flex;
      .left {
        padding-top: 24px;
        width: 240px;
      }
      .right {
        border-left: 1px solid #262626;
        border-right: 1px solid #262626;
        width: 960px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue